module.exports = "<div class=\"breadcrumb\">\n    <div class=\"container\">\n        <a routerLink=\"/\">Hjem</a> / <span class=\"current-page\">Fylker</span>\n    </div>\n</div>\n<div class=\"fylker-overview\">\n    <div class=\"container\" *ngIf=\"node\">\n        <h1 class=\"styled-title-1\">{{node.title}}</h1>\n        <div class=\"flex-container\">\n            <base-card class=\"flex-box\" *ngFor=\"let card of node.children\" [card]=\"card\"></base-card>\n        </div>\n    </div>\n    <div class=\"container\" *ngIf=\"!node\">\n        <h2>loading...</h2>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/+app/+fylker/overview/template.html
// module id = 793
// module chunks = 1